import { create } from "zustand";

import { GoalStore, GoalStoreProps } from "../types";

export const useGoalStore = create<GoalStore>((set) => ({
  goalProps: {},
  setGoalProps: (goalProps: GoalStoreProps) => set(() => ({ goalProps })),
}));
